export const GOOGLE_LIBRARIES = ['places'];
export const GOOGLE_API_VERSION = 'quarterly';
